import * as React from 'react'
import styles from './Section.sass'
import Spinner from 'components/Spinner'
import { extractMessageFromError } from 'utils/error-util'

export const SectionLoading = () => (
  <div className={styles.sectionLoading}>
    <Spinner />
  </div>
)

interface SectionErrorProps {
  title: React.ReactNode
  error: unknown
}

export const SectionError = ({ title, error }: SectionErrorProps) => (
  <div className={styles.sectionError}>
    <div className={styles.sectionErrorTitle}>{title}</div>
    <div className={styles.sectionErrorMessage}>
      {extractMessageFromError(error)}
    </div>
  </div>
)
